import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalQPage9, { ICustomProps } from './index';
import { InputFieldConfig } from '../../../../types';

const mapStateToProps = (state: ApplicationState): ICustomProps => {
  const {
    VisaSupport: visaSupportConfig,
  }: {
    VisaSupport: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page9;

  const { visaSupport = undefined } = state.student.offer;

  const visaSupportVisible = true;
  const visaSupportMandatory = true;

  // prettier-ignore
  const complete =
    (!visaSupportVisible || !visaSupportMandatory || visaSupport !== undefined)

  return {
    sectionTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    complete,
    currentStep: 9,
    steps: 10,
    visaSupport,
    visaSupportVisible,
    visaSupportConfig,
    config: state.student.config,
  };
};

export default connect(mapStateToProps)(PersonalQPage9);
